import { initializeApp } from "firebase/app";
import { getDatabase } from 'firebase/database'
import { getAuth } from 'firebase/auth'
const firebaseConfig = {

  apiKey: "AIzaSyASU_QtksU0eqqbjpamNh9N_jJLsrbYMSc",
  authDomain: "todo-list-6647c.firebaseapp.com",
  databaseURL: "https://todo-list-6647c-default-rtdb.firebaseio.com",
  projectId: "todo-list-6647c",
  storageBucket: "todo-list-6647c.appspot.com",
  messagingSenderId: "113097992278",
  appId: "1:113097992278:web:faedb094ec785a911473f7",
  measurementId: "G-66TEPWLL0X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const auth = getAuth(); 